import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createSecurityGroup,
  updateSecurityGroup,
  deleteSecurityGroup,
} from '../services/security-groups';
import type { InvoicingMode } from '../types/security-admin.types';

export function useSecurityGroupMutations(id?: string) {
  const queryClient = useQueryClient();

  const createMutation = useMutation({
    mutationFn: createSecurityGroup,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['security-groups'] });
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ id: groupId, payload }: { id: string; payload: { name: string; invoicing_mode: InvoicingMode } }) =>
      updateSecurityGroup(groupId, payload),
    onSuccess: () => {
      if (id) queryClient.invalidateQueries({ queryKey: ['security-group', id] });
      queryClient.invalidateQueries({ queryKey: ['security-groups'] });
    },
  });

  const deleteMutation = useMutation({
    mutationFn: deleteSecurityGroup,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['security-groups'] });
    },
  });

  return { createMutation, updateMutation, deleteMutation };
}
